import { FC } from 'react'

import { CreditCard, DollarSign, Pen, Smartphone, Wallet } from 'lucide-react'

import { Badge } from '../../../../components/ui/badge'

import { cn } from '../../../../lib/utils'

import { IPaymentType, PAYMENT_TYPE } from '../../../../types/payment'

interface PaymentMethodIconProps {
  paymentType: IPaymentType
  cardNumber?: string | null
  className?: string
}

export const PaymentMethodIcon: FC<PaymentMethodIconProps> = ({
  paymentType,
  cardNumber,
  className,
}) => {
  if (!paymentType) return null
  switch (paymentType) {
    case PAYMENT_TYPE.CARD:
      return (
        <Badge variant="plain" className={cn('text-gray-600', className)}>
          <CreditCard className="w-3 h-3 mr-1" /> Credit card {cardNumber && `CC *${cardNumber}`}
        </Badge>
      )
    case PAYMENT_TYPE.CASH:
      return (
        <Badge variant="plain" className={cn('text-gray-600', className)}>
          <DollarSign className="w-3 h-3 mr-1" /> Cash
        </Badge>
      )
    case PAYMENT_TYPE.CHECK:
      return (
        <Badge variant="plain" className={cn('text-gray-600', className)}>
          <Pen className="w-3 h-3 mr-1" /> Check
        </Badge>
      )
    case PAYMENT_TYPE.PAYPAL:
      return (
        <Badge variant="plain" className={cn('text-gray-600', className)}>
          <Wallet className="w-3 h-3 mr-1" /> PayPal
        </Badge>
      )
    case PAYMENT_TYPE.VENMO:
      return (
        <Badge variant="plain" className={cn('text-gray-600', className)}>
          <Smartphone className="w-3 h-3 mr-1" /> Venmo
        </Badge>
      )
    default:
      return null
  }
}
